
module.exports = {
  "Yes": "होय",
  "Male": "पुरुष",
  "Female": "महिला",
  "Other": "इतर",
  "Non": "មិនមែន",
  "Spouse": "ប្តី ប្រពន្ធ",
  "Child": "កូន",
  "husband": "ប្តី",
  "brother": "បងប្អូនប្រុស",
  "sister": "បងប្អូនស្រី",
  "grandfather": "លោកតា",
  "grandmother": "លោកយាយ",
  "grandson": "ចៅប្រុស",
  "granddaughter": "ចៅស្រី",
  "uncle": "ពូ",
  "aunt": "មីង",
  "nephew": "ក្មួយប្រុស",
  "niece": "ក្មួយស្រី",
  "cousin": "បងប្អូនជីដូនមួយ",
  "friend": "មិត្ត",
  "Monthly": "मासिक",
  "Yearly": "वार्षिक",
  "Security": "សន្តិសុខ",
  "and": "និង",
  "Sub": "អនុ",
  "Admin": "प्रशासक",
  "Comment": "टिप्पणी",
  "Description": "वर्णन",
  "See": "ឃើញ",
  "Make": "បង្កើត",
  "ON": "នៅលើ",
  "Amount": "ចំនួន",
  "Added": "បន្ថែម",
  "Successfully": "ដោយជោគជ័យ",
  "Updated": "अपडेट केले",
  "Your": "របស់អ្នក",
  "Form": "ទម្រង់",
  "form": "ទម្រង់",
  "is": "គឺ",
  "submitted": "បានបញ្ជូន",
  "Manage": "គ្រប់គ្រង",
  "marked": "សម្គាល់",
  "with": "ជាមួយ",
  "are": "គឺ",
  "required": "តម្រូវការ",
  // "Monthly":"ប្រចាំខែ",
  "Hourly": "ប្រចាំម៉ោង",
  "Weekly": "साप्ताहिक",
  "OK": "យល់ព្រម",
  "Complaint": "ត្អូញត្អែរឬពាក្យបណ្តឹង",
  "From": "पासून",
  "Subject": "ប្រធានបទ",
  "Category": "ប្រភេទ",
  "Number of Days Outstanding": "ចំនួនថ្ងៃដែលលើស",
  "Open": "उघडा",
  "Are you sure?": "तुम्हाला खात्री आहे का?",
  "that you want to delete this record?": "តើអ្នកចង់លុបកំណត់ត្រានេះ?",
  "Deleted": "លុប",

  "View": "पहा",
  "Against": "ប្រឆាំង",
  "Uploaded": "ផ្ទុកឡើង",
  "Taken": "បានយក",
  "Attendance": "उपस्थिती",
  "In-Time": "ម៉ោងចូល",
  "Out-Time": "ម៉ោងចេញ",
  "Total": "एकूण",
  "Work": "ធ្វើការ",
  "Time": "वेळ",
  "Break": "សម្រាក",
  "Are you sure that you want to edit this record which done by hr admin?": "តើអ្នកប្រាកដថាអ្នកចង់កែសម្រួលកំណត់ត្រានេះដែលធ្វើឡើងដោយអ្នកគ្រប់គ្រងទេ?",
  "Are you sure that you want to edit this record which done by employee login?": "តើ​អ្នក​ប្រាកដ​ថា​អ្នក​ចង់​កែសម្រួល​កំណត់​ត្រា​នេះ​ដែល​ធ្វើ​ឡើង​ដោយ​ការ​ចូល​របស់​បុគ្គលិកទេ?",
  "Deleted Successfully": "លុប​ដោយ​ជោគជ័យ",
  "Archived": "ទុកជាឯកសារ",
  "Check In Radius Check": "កំណត់ទីតាំងចូល",
  "Check Out Radius Check": "កំណត់ទីតាំងចេញ",
  "Done By HR ADMIN": "ធ្វើដោយអ្នកគ្រប់គ្រងធនធានមនុស្ស",
  "Write reason of delete:": "សរសេរមូលហេតុនៃការលុប:",
  //"Are you sure?":"តើអ្នកប្រាកដទេ?",
  "Are you sure that you want to delete this record?": "តើ​អ្នក​ប្រាកដ​ថា​អ្នក​ចង់​លុប​កំណត់​ត្រា​នេះ?",
  "ADD": "បន្ថែម",
  "Hrs": "ម៉ោង",
  "Min": "នាទី",
  "Enter Rest Time as Hrs:Min": "បញ្ចូលម៉ោងសម្រាកជាម៉ោង: នាទី",
  "Enter Early Leaving as Hrs:Min": "ចូលការចាកចេញមុនម៉ោងជាម៉ោង:នាទី",
  "Please enter In time": "សូមបញ្ចូលម៉ោងចូល",
  "Please enter Out time": "សូមបញ្ចូលម៉ោងចេញ",
  "Can not Add Attendance": "មិន​អាច​បន្ថែម​វត្តមាន",
  "YYYY-MM-DD": "ឆ្នាំ-ខែ-ថ្ងៃ",
  "All fields marked with * are required": "ឯកសារទាំងអស់ដែលបានសម្គាល់ដោយផ្កាយ *គឺតម្រូវ",
  "Positions": "តួនាទី",
  "Departments": "ផ្នែក",
  "Actual": "ជាក់ស្តែង",
  "Reason": "कारण",
  "Can not Add Privilege": "មិនអាចបន្ថែមសិទ្ធិបានទេ",
  "Can not Edit Privilege": "មិន​អាច​កែសម្រួល​សិទ្ធ",
  "Can not Delete Privilege": "មិនអាចលុបសិទ្ធ",
  "Pending": "प्रलंबित",
  "Approved": "मंजूर",
  "Rejected": "नाकारले",
  "Please": "សូម",
  //"Add":"បន្ថែម",
  "Check Your Leave Bank": "ពិនិត្យសមតុល្យវត្តមានរបស់អ្នក",
  "From Date should not be greater than To Date": "ចាប់ពីកាលបរិច្ឆេទ មិនគួរធំជាង ដល់កាលបរិច្ឆេទទេ",
  //"Check Your Leave Bank":"ពិនិត្យសមតុល្យវត្តមានរបស់អ្នក",
  "Please add leave templete for this employee ": "សូម​បន្ថែម​គំរូ​ការ​ឈប់​សម្រាក​សម្រាប់​បុគ្គលិក​នេះ",
  "Leave present at this date": "វត្តមាន​នៅ​ក្នុងកាលបរិច្ឆេទ​នេះ",
  "can": "អាច",
  "not": "ទេ",
  "Start": "ចាប់ផ្តើម",
  "End": "បញ្ចប់",
  "Duration": "កំឡុងពេល",
  "Starts in first half": "ចាប់ផ្តើមនៅក្នុងពាក់កណ្តាលទីមួយ",
  "Starts in second half": "ចាប់ផ្តើមនៅពាក់កណ្តាលទីពីរ",
  "Full Day Leave": "សម្រាកពេញ១ថ្ងៃ",
  "Post Edit Remark": "ប្រកាសកែសម្រួលកំណត់ចំណាំ",
  "Attachment": "ឯកសារ​ភ្ជាប់",
  "Staff": "បុគ្គលិក",
  "Staffs": "បុគ្គលិក",
  "Exists": "មានស្រាប់",
  "Not": "មិន",
  "Found": "រកឃើញ",
  "Any": "ណាមួយ",
  "App": "កម្មវិធី",
  "URL": "URL",
  "Go to App Url": "ចូលទៅកាន់កម្មវិធី Url",
  "Created At": "បង្កើតឡើងនៅ",
  "Announcement": "សេចក្តីជូនដំណឹង",
  "Announcements": "សេចក្តីជូនដំណឹង",
  "Success": "यशस्वी",
  "Available": "អាចប្រើបាន",
  "Model": "ម៉ូឌែល",
  "Asset": "ទ្រព្យសកម្ម",
  "Assigned": "ចាត់តាំង",
  "Issue On": "ថ្ងៃដែលបង្កើត",
  "Sr": "លេខ​សម្គាល់",
  "Please Start the camera": "សូម​ចាប់​ផ្តើម​កាមេរ៉ា",
  "Please add the image": "សូមបញ្ចូលរូបភាព",
  "Your last Checked out": "ចុងក្រោយរបស់អ្នកបានចេញក្រៅ",

  "Bulk Import Failed": "ការនាំចូលជាក្រុមបានបរាជ័យ",
  "in": "ក្នុង",
  "Sample": "គំរូ",
  "CSV": "CSV",
  "File": "ឯកសារ",
  "Upload": "अपलोड",
  "You must set location allow": "អ្នកត្រូវតែកំណត់ទីតាំងអនុញ្ញាត",
  "Check Inout": "ពិនិត្យការបញ្ចូល",
  "Submit": "सबमिट करा",
  "Retry": "ព្យាយាមម្តងទៀត",
  "You already Checked In": "អ្នក​បាន​ចូល​រួច​ហើយ",
  "Check In": "चेक इन",
  "Check Out": "चेक आउट",
  "Latitude": "រយៈទទឹង",
  "Longitude": "រយៈបណ្តោយ",
  "List": "បញ្",
  "Employees": "कर्मचारी",
  "Dashboard": "डॅशबोर्ड",
  "Select": "निवडा",
  "Organization": "संस्था",
  "Status": "स्थिती",
  "Department": "विभाग",
  "Position": "តួនាទី",
  "Export": "निर्यात",
  "Import": "आयात",
  "Update": "अपडेट करा",
  "Qrcode": "ខ្យូអ៊រកូដ",
  "Search": "शोधा",
  "No": "नाही",
  "New": "ថ្មី",
  "Complaints": "ត្អូញត្អែរ",
  "Information": "माहिती",
  "Employee": "कर्मचारी",
  "Email": "ईमेल",
  "Mobile": "मोबाइल",
  "Action": "कृती",
  "Add": "जोडा",
  "Edit": "संपादित करा",
  "Basic": "មូលដ្ឋាន",
  "Info": "ពត៌មាន",
  "Leaves": "रजा",
  "Points": "ពិន្ទុ",
  "Documents": "ឯកសារ",
  "Assets": "ទ្រព្យសកម្ម",
  "Salary": "पगार",
  "Note": "សម្គាល់",
  "Payslips": "ចុងសន្លឹកប្រាក់ខែ",
  "Emergency": "បន្ទាប់",
  "Contacts": "ទំនាក់ទំនង",
  "First": "មុន",
  "Name": "नाव",
  "ID": "លេខសម្គាល់",
  "Last": "ចុងក្រោយ",
  "Middle": "កណ្តាល",
  "Address": "पत्ता",
  "Gender": "लिंग",
  "Date": "तारीख",
  "Of": "នៃ",
  "Birth": "កើត",
  "Timezone": "ល្វែងម៉ោង",
  "Location": "ទីតាំង",
  "Long": "វែង",
  "Lat": "ខ្លី_KH",
  "Restrict": "ដាក់កម្រិត",
  "CheckIn": "ម៉ោងចូល",
  "Radius": "កាំ",
  "CheckOut": "ម៉ោងចេញ",
  "Nationality": "សញ្ជាតិ",
  "Resident": "អ្នកស្រុក",
  "Shift": "शिफ्ट",
  "Group": "ក្រុម",
  "JD": "ពិពណ៌នាការងារ",
  "Title": "ប្រធានបទ",
  "Access": "ការចូលប្រើ",
  "UserType": "ប្រភេទអ្នកប្រើប្រាស់",
  "QR": "ខ្យូអ៊រ",
  "Download": "डाउनलोड",
  "Cancel": "रद्द करा",
  "Enter": "បញ្ចូល",
  "Password": "पासवर्ड",
  "In-Active": "មិនដំណើរការ",
  "Dependent": "ឯករាជ្យ",
  "Relation": "ទំនាក់ទំនង",
  "Present": "उपस्थित",
  "Age": "អាយុ",
  "Save": "जतन करा",
  "changes": "ផ្លាស់ប្តូរ",
  "Leave": "रजा",
  "Template": "គំរូ",
  "Current": "បច្ចុប្បន្ន",
  "Balance": "សមតុល្យ",
  "Allowed": "អនុញ្ញាត",
  "Negative": "អវិជ្ជមាន",
  "Transaction": "ប្រត្តិបត្តិការ",
  "History": "ប្រវត្តិសាស្រ្ត",
  "Manual": "សៀវភៅណែនាំ",
  "Credit": "ឥណទាន",
  "Debit": "ឥណពន្ធ",
  "Close": "बंद करा",
  "Frequency": "ហ្រ្វកង់",
  "Quantity": "បរិមាណ",
  "Paycode": "លេខកូដបង់ប្រាក់",
  "Type": "ប្រភេទ",
  "Opening": "បើក",
  "All": "सर्व",
  "Document": "ឯកសារ",
  "Days": "दिवस",
  "to": "ទៅ",
  "Already": "រួចហើយ",
  "Expired": "ផុតកំណត់",
  "Expiry": "ផុតកំណត់",
  "Remark": "ចំណាំ",
  "Declaration": "សេចក្តីប្រកាស",
  "Issue": "បញ្ហា",
  "Return": "ត្រឡប់មកវិញ",
  "Allowance": "भत्ता",
  "Code": "កូដ",
  "Taxable": "ជាប់ពន្ធ",
  "tax": "ពន្ធ",
  "Telephone": "ទូរស័ព្ទ",
  "Distance": "ចម្ងាយ",
  "Check out details are Not Available": "ពត៌មានលម្អិតអំពីម៉ោងចូលមិនមានទេ",
  "Details": "तपशील",
  "Get": "ទទួល",
  "Image": "រូបភាព",
  "This entry is generated by Admin": "ធាតុនេះត្រូវបានបង្កើតឡើងដោយអ្នកគ្រប់គ្រង",
  "for": "សម្រាប់",
  "CheckInOut": "ម៉ោងចេញចូល",
  "enter": "បញ្ចូល",
  "Email ID": "លេខសំគាល់​សារ​អេ​ឡិច​ត្រូ​និ​ច",
  "password": "លេខសំងាត់",
  "Incorrect": "មិន​ត្រឹមត្រូវ",
  "Credentials": "លិខិតសម្គាល់",
  "Login": "लॉगिन",
  "Unsuccessful": "មិនជោគជ័យ",
  "Forgot": "ភ្លេច",
  "Sign Up Now": "ចុះឈ្មោះឥឡូវនេះ",
  "Sign in": "ចូល",
  "Banner": "ផ្ទាំងផ្សព្វផ្សាយ",
  "Size": "ទំហំ",
  "Sequence": "លំដាប់",
  "Publish": "បោះពុម្ពផ្សាយ",
  "Blog": "ពត៌មានចែករំលែក",
  "Blogs": "ពត៌មានចែករំលែក",
  "Draft": "សេចក្តីព្រាង",
  "Unpublished": "មិនបានផ្សព្វផ្សាយ",
  "Published": "ផ្សព្វផ្សាយ",
  "type": "ប្រភេទ",
  "Video": "វីដេអូ",
  "Back to": "ត្រឡប់ទៅ",
  "Chapters": "ជំពូក",
  // "Chapters":"ជំពូក",
  "Chapter": "ជំពូក",
  "Topics": "ប្រធានបទ",
  "Under this": "នៅក្រោមនេះ",
  "Course": "វគ្គសិក្សា",
  "PDF": "ឯកសារ PDF",
  "VIDEO": "វីដេអូ",
  "Topic": "ប្រធានបទ",
  "Involved": "ពាក់ព័ន្ធ",
  "By": "ដោយ",
  "Welcome back": "សូមស្វាគមន៍ការត្រឡប់មកវិញ",
  "Data": "ទិន្នន័យ",
  "For": "សម្រាប់",
  "From Date": "ពីកាលបរិច្ឆេទ",
  "To Date": "ដល់កាលបរិច្ឆេទ",
  "TODAY'S": "ថ្ងៃនេះ",
  "ATTENDANCE": "វត្តមាន",
  "THIS": "នេះ",
  "MONTH": "ខែ",
  "LEAVE": "ច្បាប់",
  "TOTAL": "សរុប",
  "ORGANIZATIONS": "ក្រុមហ៊ុន",
  "ACTIVE": "សកម្ម",
  "EMPLOYEES": "និយោជិត",
  "Today's": "ថ្ងៃនេះ",
  "Project Head": "ប្រធានគម្រោង",
  "Contact No": "លេខទំនាក់ទំនង",
  "Add More": "បន្ថែម​ទៀត",
  "Guest": "ភ្ញៀវ",
  "Visit To": "ទៅជួប",
  "License Plate": "ផ្លាកលេខ",
  "Add Checkout Time": "បន្ថែមម៉ោងចេញ",
  "Business Visit": "ជួបអំពីរឿងអាជីវកម្ម",
  "Meeting": "ការប្រជុំ",
  "Personal Visit": "អំពីរឿងផ្ទាល់ខ្លួន",
  "Interview": "मुलाखत",
  "Presentation": "ធ្វើបទ​បង្ហាញ",
  "Sales Visit": "ដំណើរទស្សនកិច្ចផ្នែកលក់",
  "Client Visit": "ដំណើរទស្សនកិច្ចរបស់អតិថិជន",
  "Supplier Visit": "ដំណើរទស្សនកិច្ចរបស់អ្នកផ្គត់ផ្គង់",
  //"Other":"ផ្សេងៗ",
  "Take": "យក",
  "HR": "एचआर",
  "Email Already Exists": "អ៊ីម៉ែលនេះមានរួចហើយ",
  "HR Code Already Exists": "កូដធនធានមនុស្សមានរួចហើយ",
  "Account Name Already Exists": "ឈ្មោះគណនីមានរួចហើយ",
  "Account Name should not be greater than 10 characters": "ឈ្មោះគណនីមិនគួរលើសពី 10 តួអក្សរ",
  "Database not found with given account name, Please create database first": "រកមិនឃើញមូលដ្ឋានទិន្នន័យដែលមានឈ្មោះគណនីដែលបានផ្ដល់ឱ្យទេ សូមបង្កើតមូលដ្ឋានទិន្នន័យជាមុនសិន",
  "Database not available to create HR admin": "មិនមានមូលដ្ឋានទិន្នន័យដើម្បីបង្កើតអ្នកគ្រប់គ្រងធនធានមនុស្សទេ",
  "Min.Amount": "ចំនួនទឹកប្រាក់អប្បបរមា",
  "Max.Amount": "ចំនួនទឹកប្រាក់អតិបរមា",
  "Base amount": "ចំនួនទឹកប្រាក់មូលដ្ឋាន",
  "Percentage": "ភាគរយ",
  "Tax": "कर",
  "Dependence Allowance": "ប្រាក់ឧបត្ថម្ភសម្រាប់ភាពអាស្រ័យ",
  "Tax Bracket List": "បញ្ជីគ្រប់គ្រងពន្ធ",
  "Tax Bracket": "គ្រប់គ្រងពន្ធ",
  "Super User": "អ្នកប្រើប្រាស់ជាន់ខ្ពស់",
  "Day": "दिवस",
  "Monday": "सोमवार",
  "Rest-Time": "ម៉ោងសម្រាក",
  "tuesday": "ថ្ងៃអង្គារ",
  "Wednesday": "बुधवार",
  "Thursday": "गुरुवार",
  "Friday": "शुक्रवार",
  "Saturday": "शनिवार",
  "Sunday": "रविवार",
  "Signup": "ចុះ​ឈ្មោះ",
  "Requests": "សំណើ",
  "Reference": "យោង",
  "Account": "គណនី",
  "Personal": "ផ្ទាល់ខ្លួន",
  "Create": "तयार करा",
  "user Roles": "តួនាទីអ្នកប្រើប្រាស់",
  "Task": "ភារកិច្ច",
  "In Progress": "កំពុង​ដំណើរការ",
  "Completed": "पूर्ण",
  "Logs Present in this Task so cant be deleted": "កំណត់ហេតុមានវត្តមាននៅក្នុងកិច្ចការនេះ ដូច្នេះមិនអាចលុបបានទេ",
  "Log Text": "កំណត់ហេតុអត្ថបទ",
  "Logs": "កំណត់ហេតុ",
  "Projects": "គម្រោង",
  "Member": "សមាជិក",
  "Moderate": "មធ្យម",
  "Low": "ទាប",
  "High": "ខ្ពស់",
  "Very High": "ខ្ពស់​ណាស់",
  "Priority": "អាទិភាព",
  "Visit": "ទស្សនា",
  "Weight": "ទំងន់",
  "Value": "តម្លៃ",
  "Score": "ពិន្ទុ",
  "Completion": "ការបញ្ចប់",
  "Uploaded image has not valid Height and Width": "រូបភាពដែលបានបង្ហោះមិនមានកម្ពស់ និងទទឹងត្រឹមត្រូវ",
  "Promotion": "ការផ្សព្វផ្សាយ",
  "Redirect": "ប្តូរទិស",
  "Task Presnt in this Project so cant be deleted": "ភារកិច្ចមានវត្តមាននៅក្នុងគម្រោងនេះ ដូច្នេះមិនអាចលុបបានទេ",
  "Now": "ឥឡូវ​នេះ",
  "Importance": "សារៈសំខាន់",
  "Performance Kpi": "ការបង្ហាញសូចនាករសំខាន់នៃការអនុវត្ត",
  "Please add the reason of delete": "សូមបន្ថែមមូលហេតុនៃការលុប",
  "Role": "តួនាទី",
  "Please select at least one module": "សូមជ្រើសរើសយ៉ាងហោចណាស់មួយ",
  "Analyst": "វិភាគ",
  "analytics": "ការវិភាគ",
  "Top Selling": "លក់ដាច់ជាងគេ",
  "Shop": "ហាង",
  "Cart": "កន្ត្រក",
  "File size less than 1 MB": "ទំហំឯកសារតិចជាង 1 MB",
  "Check Discount Price": "ពិនិត្យការបញ្ចុះតម្លៃ",
  "Required": "आवश्यक",
  "Investigating": "កំពុងស៊ើបអង្កេត",
  "Incident": "ឧបទ្ទវហេតុ",
  "Job": "नोकरी",
  "Level": "កម្រិត",
  "Grade": "ថ្នាក់",
  "Attach": "ភ្ជាប់",
  "Functions": "មុខងារ",
  "Qualification": "កម្រិតវប្បធម៌",
  "Responsibilities": "ទំនួលខុសត្រូវ",
  "Reporting": "របាយការណ៍",
  "Perks": "អត្ថប្រយោជន៍",
  "Benefits": "ផលប្រយោជន៍",
  "Make-Model": "ធ្វើគំរូ",
  "Check IN/OUT": "ពិនិត្យចូល/ចេញ",
  "Please Upload the File": "សូមភ្ជាប់ឯកសារ",
  "No mid month": "មិនមានពាក់កណ្តាលខែទេ",
  "Mid Month": "ពាក់កណ្តាលខែ",
  "Payroll": "पेरोल",
  "Process": "ដំណើរការ",
  "Bonus": "ប្រាក់រង្វាន់",
  "Working": "ធ្វើការ",
  "Test": "សាកល្បង",
  "Live": "រស់នៅ",
  "Line": "ជួរ",
  "Entry": "ការចូល",
  "Currency": "រូបិយប័ណ្ណ",
  "Rate": "អត្រា",

  "Banners": "ផ្ទាំងពាពិជ្ជកម្ម",
  "Orders": "កម្ម៉ង់",
  "Product": "ផលិតផល",
  "Pay Codes": "លេខកូដបង់ប្រាក់",
  "Comments": "टिप्पण्या",
  "Career": "អាជីព",
  "Profile": "प्रोफाइल",
  "Employee Presence": "វត្តមាននិយោជិត",
  "Employee Absence": "អវត្តមាននិយោជិត",
  "My Job Description": "ការពិពណ៌នាការងាររបស់ខ្ញុំ",
  "Job Description": "नोकरीचे वर्णन",
  "Settings": "सेटिंग्ज",
  "Public Holidays": "ថ្ងៃឈប់សម្រាកសាធារណៈ",
  "Master Department": "នាយកដ្ឋាន",
  "Point Declaration": "ពិន្ទុសេចក្តីប្រកាស",
  "User Role": "តួនាទីអ្នកប្រើប្រាស់",
  "Admin Apps": "កម្មវិធីគ្រប់គ្រង",
  "Groups": "ក្រុម",
  "Employee Bulk Import": "ការ​នាំចូល​ច្រើន​របស់​បុគ្គលិក",
  "Guests": "ភ្ញៀវ",
  "Check In Out": "ពិនិត្យចូលនិងចេញ",
  "Incident Report": "របាយការណ៍​គ្រោះថ្នាក់",
  "Tasks": "ភារៈកិច្ច",
  "Work Plan": "ផែនការការងារ",
  "My": "របស់ខ្ញុំ",
  "Promotions": "ការផ្សព្វផ្សាយ",
  "Payroll Line Entry": "ការចូលបន្ទាត់ប្រាក់ខែ",
  "Employee Chat": "ការជជែកជាមួយនិយោជិត",
  "Messages": "संदेश",
  "Training": "प्रशिक्षण",
  "SignUp Requests": "សំណើរចុះឈ្មោះ",
  "My Profile": "ប្រវត្តិរូបរបស់ខ្ញុំ",
  "Employee Career": "អាជីពបុគ្គលិក",
  "Job Post": "ប្រកាសការងារ",
  "Application List": "បញ្ជីពាក្យសុំ",
  "Job Frontend Url": "តំណរភ្ជាប់ការងារខាងមុខ",
  "Manage Shifts": "គ្រប់គ្រងកាលវិភាគ",
  "Shift Scheduler": "កំណត់ពេលកាលវិភាគ",
  "Shift Scheduler History": "ប្រវត្តិនៃការកំណត់កាលវិភាគ",
  "Shift Schedule": "ការផ្លាស់ប្តូរកាលវិភាគ",
  "Constants": "ថេរ",
  "No Preference": "គ្មានចំណូលចិត្ត",
  "Fresher": "ស្រស់ជាង",
  "Year": "वर्ष",
  "Short Description": "ការពិពណ៌នាខ្លី",
  "Long Description": "ការពិពណ៌នាវែង",
  "Add Thumbnail Image": "បន្ថែមរូបភាពតូច",
  "Enter Valid link": "បញ្ចូលតំណរត្រឹមត្រូវ",
  "In Stock": "នៅ​ក្នុង​ស្តុក",
  "Out Of Stock": "អស់ពី​ស្តុក",
  "In Active": "នៅក្នុងសកម្ម",
  "Ordered": "បានបញ្ជាទិញ",
  "Accepted": "ទទួលយក",
  "Rejected and Closed": "បដិសេធ និងបិទ",
  "Shipped/InTransit": "ដឹកជញ្ជូន/ឆ្លងកាត់",
  "Completed and Closed": "បានបញ្ចប់ និងបិទ",
  "Cancelled and Closed": "លុបចោល និងបិទ",
  "Order No": "លេខបញ្ជាទិញ",
  "Order On": "បញ្ជាទិញនៅលើ",
  "Product Feature": "លក្ខណៈពិសេសផលិតផល",
  "Subtotal": "សរុបរង",
  "No items in the cart": "មិនមានទំនិញនៅក្នុងរទេះទេ",
  "Place Order": "ដាក់បញ្ជា",
  "Change": "ផ្លាស់ប្តូរ",
  // "Select":"ជ្រើសរើស",
  "Language": "भाषा",

  ////////////////////
  "Job Title": "नोकरीचे पद",
  "All Employee": "និយោជិតទាំងអស់",
  "Day Leave": "ថ្ងៃឈប់សម្រាក",
  "System Logs": "កំណត់ហេតុចូលប្រព័ន្ធ",
  "Employee Documents": "ឯកសារនិយោជិត",
  "Leave Types": "ប្រភេទច្បាប់",
  "Allowance Type": "ប្រភេទប្រាក់ឧបត្ថម្ភ",
  "Allowance Code": "លេខកូដប្រាក់ឧបត្ថម្ភ",
  "Note Code": "លេខកូដចំណាំ",
  "Document Code": "លេខកូដឯកសារ",
  "Comment Category": "ប្រភេទមតិយោបល់",
  "Comment Type": "ប្រភេទមតិ",


  "My Shift Schedule": "កាលវិភាគរបស់ខ្ញុំ",
  "My Orders": "ការបញ្ជាទិញរបស់ខ្ញុំ",
  "Organization Blogs": "ពត៌មានរបស់អង្គភាព",
  "My Attendance": "វត្តមានរបស់ខ្ញុំ",
  "My Leaves": "ច្បាប់របស់ខ្ញុំ",
  "Access Code": "លេខកូដចូលប្រើ",
  "My Points": "ពិន្ទុរបស់ខ្ញុំ",
  "My Documents": "ឯកសារ​របស់​ខ្ញុំ",
  "My Assests": "ទ្រព្យសម្បត្តិរបស់ខ្ញុំ",
  "My Payslips": "ចុងសន្លឹកបៀរវត្សរបស់ខ្ញុំ",
  "Sub Admin": "អ្នកគ្រប់គ្រងរង",
  "Manage Tax Brackets": "គ្រប់គ្រងប្រភេទអត្រាពន្ធ",
  "All Shifts": "កាលវិភាគទាំងអស់",
  "Shift Scheduler Import": "ការនាំចូលតារាងកាលវិភាគ",
  "Project Task": "គម្រោងភារៈកិច្ច",
  "Employee Training": "ការបណ្តុះបណ្តាលនិយោជិត",
  "Employee Shop": "ហាងនិយោជិត",
  "Product Category": "ប្រភេទ​ផលិតផល",
  "Products": "ផលិតផល",
  "Public Holiday": "ថ្ងៃសម្រាក​​សាធារណៈ",
  "Blog Type": "ប្រភេទពត៌មាន",
  "Job Type": "ប្រភេទ​ការងារ",
  "Course Type": "ប្រភេទវគ្គសិក្សា",
  "Annoucement Type": "ប្រភេទសេចក្តីជូនដំណឹង",


  "Add/Subtract": "បន្ថែម/ដក",
  "Mood": "អារម្មណ៍",
  "Negative Balance": "តុល្យភាពអវិជ្ជមាន",
  "Leave Bank Report": "ទុករបាយការណ៍ធនាគារ",
  "Payroll Type": "ប្រភេទប្រាក់បៀវត្សរ៍",
  "Flat Salary": "ប្រាក់ខែរាបស្មើ",
  "Salary Attendance": "ប្រាក់ខែចូលរួម",
  "Salary Attendance + OT": "ប្រាក់ខែចូលរួម + OT",
  "Hourly Wages": "ប្រាក់ឈ្នួលម៉ោង",
  "Deduction": "ការកាត់ប្រាក់",
  "Adjustment": "ការកែតម្រូវ",
  "Settlements": "ការតាំងទីលំនៅ",
  "Current Balance": "តុល្យភាព​បច្ចុប្បន្ន",
  "Allowed Negative Balance": "សមតុល្យអវិជ្ជមានដែលបានអនុញ្ញាត",
  "No Record Found": "រកមិនឃើញកំណត់ត្រាទេ។",
  //"Work Schedular":"Work Schedular",



  ////////Date 23/2/2kl
  "Upcoming": "នាពេលខាងមុខ",
  //"Today's":"Today's",
  "Absent": "अनुपस्थित",
  "Apply": "लागू करा",
  "Database Host": "Database Host",
  "Database User": "Database User",
  "Database Password": "Database Password",
  "Primary Database Name": "Primary Database Name",
  "Payroll Database Name": "Payroll Database Name",
  "Language Translation Type": "Language Transalation Type",
  "Google Transaltor": "Google Transaltor",
  "Custom": "Custom",
  "Default Language": "Default Language",
  "English": "इंग्रजी",
  "Khemer": "Khemer",
  "Chinese": "Chinese",
  "More than 1 organization cannot be added": "ស្ថាប័នលើសពី 1 មិនអាចបន្ថែមបានទេ។",
  "Organization Code already exists": "លេខកូដអង្គការមានរួចហើយ",
  "Add Payslip Header or Footer or organization logo": "បន្ថែមបឋមកថា Payslip ឬបាតកថា ឬនិមិត្តសញ្ញាស្ថាប័ន",
  "Company Policy": "គោល​នយោបាយ​របស់​ក្រុម​ហ៊ុន",
  "Employee Handbook": "Employee Handbook",
  "Payslip Header": "បឋមកថា Payslip",
  "Payslip Footer": "បាតកថា Payslip",
  "Color Code": "កូដពណ៌",
  // "Sequence":"Sequence",

  /****29 march */

  "Shifts": "शिफ्ट्स",
  "Visitor": "ការផ្លាស់ប្តូរ",
  "Work Scheduler": "អ្នករៀបចំកាលវិភាគការងារ",
  "Work Scheduler History": "ប្រវត្តិអ្នករៀបចំកាលវិភាគការងារ",
  "Work Scheduler Import": "ការនាំចូលកម្មវិធីកំណត់ពេលវេលាការងារ",
  "Vehicle": "យានជំនិះ",
  "Total IN Visitor": "ចំនួនអ្នកទស្សនាសរុប",



  /////////Date 28/4/23/////////
  "Seniority Pay": "ប្រាក់ឈ្នួលចាស់",
  "Convert to USD Dollar": "បំប្លែងទៅជាប្រាក់ដុល្លារ",
  //"":"",
  //'Absent':'Absent',

  "Expire With In Days": "ផុតកំណត់ក្នុងរយៈពេលប៉ុន្មានថ្ងៃ",
  //"My Profile": "我的简历",
  "Sign out": "ចាកចេញ",
  "Outstanding": "ពូកែ",
  "Leave Bank": "ចាកចេញពីធនាគារ",

  "Settlement Import": "ការទូទាត់នាំចូល",
  "Tax Code": "លេខកូដពន្",
  "Business Promotions": "ការផ្សព្វផ្សាយពាណិជ្ជកម្",
  "HR Blog": "ប្លុក HR",
  "Job Discloursere": "ការពិភាក្សាការងារ",

  "Payroll Headers": "បឋមកថាប្រាក់ខែ",
  "Settlement Type": "ប្រភេទការទូទាត់",
  "Settlement Code": "លេខកូដទូទាត់",
  "Document Types": "ប្រភេទឯកសារ",
  "Employee Groups": "ក្រុមបុគ្គលិក",

  "Job ID": "លេខសម្គាល់ការងារ",
  "Payroll Privilege": "សិទ្ធិបើកប្រាក់បៀវត្សរ៍",
  "To": "पर्यंत",
  // "Outstanding": "杰出的",
  // "Mood": "情绪",
  "options": "ជម្រើស",
  "General": "ទូទៅ",
  "Very Sad": "ក្រៀមក្រំ​ណាស់",

  "Sad": "សោកសៅ",
  "Just OK": "គ្រាន់តែ​យល់ព្រម",
  "Good": "ល្អ",
  "Fantastic": "អស្ចារ្យ",
  "zone": "តំបន់",
  "Rest": "សម្រាក",

  "NOTE:In Time and Out Time in 24 Hrs Format": "ចំណាំ៖ ពេលវេលា និងម៉ោងចេញក្នុងទម្រង់ 24 ម៉ោង។",
  //"Please select a date":"Please select a date",
  //"Rest":"Rest",
  "Early Out": "ឆាប់ចេញ",
  "Over Time": "ហួសពេល",
  "Late In": "ចូលយឺត",
  "Previous": "मागील",

  "Records": "កំណត់ត្",
  "Check IN Out Records": "ពិនិត្យ IN Out Records",
  "Check IN": "កត់​ឈ្មោះ​ចូល",
  "Check": "ពិនិត្",
  // "Title":"Title",
  //"Address":"Address",
  "Owner": "ម្ចាស់",

  "Address Line": "ជួរ​អាស័យ​ដ្ឋាន",
  "City": "शहर",
  "State/Province": "រដ្ឋ/ខេត្",
  "Country": "देश",
  "Attendance Radius (in Meters)": "កាំវត្តមាន (គិតជាម៉ែត្រ)",
  // "Company Policy": "Company Policy",
  // "Employee Handbook": "Employee Handbook",
  // "Payslip Header": "Payslip Header",
  // "Payslip Footer": "Payslip Footer",
  "Height": "កម្ពស់",
  "Width": "ទទឹង",

  "ID Template": "គំរូលេខសម្គាល់",
  "Logo": "និមិត្តសញ្ញា",
  "Active": "सक्रिय",
  "Approved/In-Active": "បានយល់ព្រម / សកម្ម",
  "Write reason of": "សរសេរហេតុផល",
  "Are you sure that you want to In-Active this record?": "តើ​អ្នក​ប្រាកដ​ថា​អ្នក​ចង់​ធ្វើ​ឱ្យ​កំណត់ត្រា​នេះ​មិន​សកម្ម?",
  "Profile Image": "រូបភាពប្រវត្តិរូប",

  "Notice Pay": "ជូនដំណឹងបង់ប្រាក់",
  "Local Name": "ឈ្មោះក្នុងស្រុក",
  "expire": "ផុតកំណត់",
  "Settlement": "ការតាំងទីលំនៅ",
  "NOTE: In Time and Out Time in 24 Hrs Format": "ចំណាំ៖ ក្នុង​ពេល​វេលា និង​ពេល​ចេញ​ក្នុង​ទម្រង់ 24 ម៉ោង។",
  "Tuesday": "मंगळवार",

  "Pay Code": "លេខកូដបង់ប្រាក់",
  "Scheduler": "អ្នករៀបចំកាលវិភាគ",
  "Calender View": "ទិដ្ឋភាពប្រតិទិន",
  "Download Sample File": "ទាញយកឯកសារគំរូ",
  "Download Sample CSV File": "ទាញយកឯកសារ CSV គំរូ",
  "Preview Of Shift Scheduler Table": "ការមើលជាមុននៃតារាង ប្ដូរ អ្នករៀបចំកាលវិភាគ",
  "Shift Scheduler of Parent Table": "ប្តូរ អ្នករៀបចំកាលវិភាគ នៃតារាងមេ",

  "Preview": "មើលជាមុន",
  // "Half":"一半",
  "Full Month": "ពេញមួយខែ",
  "System": "ប្រព័ន្",
  "Approval": "ការយល់ព្រម",
  "Payslip": "पगार पावती",
  "Designation": "पद",
  "Multiplier": "មេគុណ",
  "Project": "គម្រោង",
  "Members": "សមាជិក",
  "Analytics": "វិភាគ",
  "Payment": "ការទូទាត់",
  "Approve": "យល់ព្រម",

  "Hours": "ម៉ោង",
  "Maternal": "មាតា",
  "Adjustment": "ការកែតម្រូវ",
  "OT": "OT",
  "Paycodes": "លេខកូដបង់ប្រាក់",
  //"Days": "天",
  "Left": "ឆ្វេង",

  "Joining": "ការចូលរួម",
  "Hiring": "ជួល",
  "Application": "अर्ज",
  "Emergancy": "គ្រាអាសន្",
  "Contact": "ទំនាក់ទំនង",
  "Print": "प्रिंट",
  "Not Consider In Payroll": "មិនពិចារណាក្នុងបញ្ជីប្រាក់បៀវត្សរ៍",
  "Sequence No": "លំដាប់លេខ",
  "Special": "ពិសេស",
  "Report": "अहवाल",
  "Summary": "សង្ខេប",
  "Out": "ចេញ",
  "Link": "តំណភ្ជាប់",
  "Url": "Url",
   "CV": "CV",
  "LinkedIn": "LinkedIn",
  "Final": "ចុងក្រោយ",
  "Open Payslips": "បើកប្រាក់បៀវត្សរ៍",
  "Close Payslips": "បិទ បញ្ជីប្រាក់បៀវត្សរ៍",
  "Reports": "अहवाल",
  "Payroll Reports": "របាយការណ៍ប្រាក់ខែ",
  "Notice Pay Reports": "សេចក្តីជូនដំណឹងអំពីរបាយការណ៍បង់ប្រាក់",
  "Staff IN OUT Reports": "បុគ្គលិកនៅក្នុងរបាយការណ៍ចេញ",
  "Leave Reports": "ចាកចេញពីរបាយការណ៍",
  "Paid": "បង់",
  "Bank": "ធនាគារ",
"Evaluated": "វាយតំលៃ",
 "Obtained": "ទទួលបាន",
 "OneTime": "OneTime",
 "Daily": "दररोज",
 "HH:MM": "ហ",
 "Base Amount": "ចំនួនទឹកប្រាក់មូលដ្ឋាន",
 "Month": "महिना",
 "Date Range": "ជួរកាលបរិច្ឆេទ",
 "Staffing": "បុគ្គលិក",
 "Requirement": "តម្រូវការ",
 "Anyalsis": "ការវិភាគ",
 "Privious": "មុន",
 "Budget": "ថវិកា",
 "To Hire": "ជួល",
 //"Work Plan":"工作计划",
 "Work Plan/KPI": "ផែនការការងារ / KPI",
"KPI": "KPI",
"Employee Evalution": "ការវាយតម្លៃបុគ្គលិក",
"KPI Project": "គម្រោង KPI",
"Detail": "លម្អិត",
"Complete": "បញ្ចប់",
//"value":"",
"Performance": "कामगिरी",
"Achieved": "សម្រេចបាន។",
"Improvement": "ការកែលម្អ",
"Core": "ស្នូល",
"Job Disclosure": "ការបង្ហាញការងារ",
"Post": "ប្រកាស",
"Employee List": "បញ្ជីបុគ្គលិក",
"Notice Pay Check": "សេចក្តីជូនដំណឹង ពិនិត្យការបង់ប្រាក់",
"My Work Schedule": "កាលវិភាគការងាររបស់ខ្ញុំ",
"Employee ID": "कर्मचारी आयडी",
"QR Code": "កូដ QR",
"IDCard": "អត្តសញ្ញាណប័ណ្ណ",
"Record Added Successfully": "កំណត់ត្រាត្រូវបានបន្ថែមដោយជោគជ័យ",
"Record Updated Successfully": "បានធ្វើបច្ចុប្បន្នភាពកំណត់ត្រាដោយជោគជ័យ",
"Can not Add the Record": "មិនអាចបន្ថែមកំណត់ត្រាបានទេ។",
"Account Code -Debit": "លេខកូដគណនី - ឥណពន្ធ",
"Account Code - Credit": "លេខកូដគណនី - ឥណទាន",
"Pension": "ប្រាក់​សោធន​និវត្តន៍",
"Locked": "ចាក់សោ",
"Show": "दाखवा",
"Saas Code": "កូដ Saas",
"Font Color": "ពណ៌ពុម្ពអក្សរ",
"Font Style": "រចនាប័ទ្មពុម្ពអក្សរ",
"Hexa Code Color Background": "ផ្ទៃខាងក្រោយពណ៌កូដ Hex",
"normal": "ធម្មតា។",
"italic": "ទ្រេត",
"oblique": "oblique",
"Reserved": "កក់ទុក",
"Error": "त्रुटी",
"mom": "ម៉ាក់",
"dad": "ប៉ា",

  // //"Documents":"Documents",កូដ Saas
  // "Expired":"Expired",
  // "in":"in",
  // "days":"days",
  // "New":"New",
  // "Complaints":"Complaints",
  // "No":"No",
  // "Messages":"Messages",
  // "Arrived":"Arrived",
  // "Leaves":"Leaves",
  // "today":"today",
  // "My Profile":"My Profile",
  // "Sign out":"Sign out",
  // "Flat Salary":"Flat Salary",
  // "Salary Attendance":"Salary Attendance",
  // "OT":"OT",
  // "Hourly Wages":"Hourly Wages",
  // "NOTE:In Time and Out Time in 24 Hrs Format":"NOTE:In Time and Out Time in 24 Hrs Format",
  // "Please select a date":"Please select a date",
  // "Rest":"Rest",
  // "Early Leaving":"Early Leaving",
  // "Over Time":"Over Time",
  // "Time Late":"Time Late",
  // "Previous":"Previous",
  // "Records":"Records",
  // "Check IN Out Records":"Check IN Out Records",
  // "Check IN":"Check IN",
  // "Select Status":"Select Status",
  // "ADD":"ADD",
  // "Export":"Export",
  // "Active":"Active",
  // "Title":"Title",
  // "Address":"Address",
  // "Owner":"Owner",
  // "Status":"Status",
  // "Action":"Action",
  // "Photo":"Photo",
  // "Select":"Select",
  // "User":"User",
  // "Employee Local Name":"Employee Local Name",
  // "Vehicle":"Vehicle",
  // "Notice Pay":"Notice Pay",
  // "See":"See",
  // "Not found":"Not found",
  // "Upcoming":"Upcoming",
  // "Absent":"Absent",
  // "Expire With in Days":"Expire With in Days",
  // "Leave Bank":"Leave Bank",
  // "To":"To",
  // "Outstanding":"Outstanding",
  // "Mood":"Mood",
  // "No options":"No options",
  // "General":"General",
  // "Very Sad":"Very Sad",
  // "Sad":"Sad",
  // "Just OK":"Just OK",
  // "Good":"Good",
  // "Fantastic":"Fantastic",
  // "Document Type List":"Document Type List",
  // "Dashboard":"Dashboard",
  // "Doc Type":"Doc Type",
  // "All":"All",
  // "Expiry By":"Expiry By",
  // "Days to expire";"Days to expire",
  // "All Expiry Type":"All Expiry Type",
  // "Days to expire":"Days to expire",
  // "Already Expired":"Already Expired",
  // "All Document Type":"All Document Type",
  // "In-Active":"In-Active",
  // "Select Department":"Select Department",
  // "Select Employee":"Select Employee",
  // "Work Schedular":"Work Schedular",
  // "Work Schedular History":"Work Schedular History",
  // "Work Schedular Import":"Work Schedular Import",
  // "Calender View":"Calender View",
  // "Choose File":"Choose File",
  // "No file chosen":"No file chosen",
  // "Download Sample File":"Download Sample File",
  // "Download Sample CSV File":"Download Sample CSV File",
  // "Upload":"Upload",
  // "Preview Of Shift Scheduler Table":"Preview Of Shift Scheduler Table",
  // "Shift Schduler of Parent Table":"Shift Schduler of Parent Table",
  // "All Organization":"All Organization",
  // "Test Payroll":"Test Payroll",
  // "Rate":"Rate",
  // "View":"View",
  // "Payslip":"Payslip",
  // "All Payroll Entry":"All Payroll Entry",
  // "Payroll Title":"Payroll Title",
  // "Employee ID":"Employee ID",
  // "Employee Name":"Employee Name",
  // "Department":"Department",
  // "Designation":"Designation",
  // "Color Code":"Color Code",
  // "Multiplier":"Multiplier",
  // "Pay Code":"Pay Code",
  // "Taxcode":"Taxcode",
  // "Project":"Project",
  // "In Progress":"In Progress",
  // "Closed":"Closed",
  // "Project ID":"Project ID",
  // "Status":"Status",
  // "Open":"Open",
  // "Id":"Id",
  // "Job Title":"Job Title",
  // "Job ID":"Job ID",
  // "Description":"Description",
  // "Close Date":"Close Date",
  // "No Of Candidates Applied":"No Of Candidates Applied",
  // "Number Of":"Number Of",
  // "Url":"Url",
  // "Normal":"Normal",
  // "Document Uploaded":"Document Uploaded",
  // "Public Jobs":"Public Jobs",
  // "Private Jobs":"Private Jobs",
  // "Course List":"Course List",
  // "Course":"Course",
  // "Select Course Type":"Select Course Type",
  // "Departments":"Departments",
  // "Description":"Description",
  // "Cancel":"Cancel",
  // "Chat":"Chat",
  // "Select Department":"Select Department",
  // "Select Organization":"Select Organization",
  // "Load All":"Load All",
  // "SKU":"SKU",
  // "Cost":"Cost",
  // "Price":"Price",
  // "Discount Price":"Discount Price",
  // "Link":"Link",
  // "Brand":"Brand",
  // "Top List":"Top List",
  // "Image Size":"Image Size",
  // "Documents Uploaded":"Documents Uploaded",
  // "Select Status":"Select Status",
  // "No":"No",
  // "View resume":"View resume",
  // "Applied For":"Applied For",
  // "Applicant":"Applicant",
  // "Application Name":"Application Name",
  // "Applicant Mobile":"Applicant Mobile",
  // "Applicant Email":"Applicant Email",
  // "Status":"Status",
  // "Remark":"Remark",
  // "Thumbnail":"Thumbnail",
  // "Business Promotion":"Business Promotion",
  // "Visitor":"Visitor",
  // "Total IN Visitor":"Total IN Visitor",
  // "QR Code":"QR Code",
  // "Phone":"Phone",
  // "Send QR Code":"Send QR Code",
  // "Not Checked Out":"Not Checked Out",
  // "History":"History",
  // "Open":"Open",
  // "Reported":"Reported",
  // "Created On":"Created On",
  // "Incident From":"Incident From",
  // "Incident Title":"Incident Title",
  // "Incident Form":"Incident Form",
  // "Level":"Level",
  // "Remark":"Remark",
  // "Status":"Status",
  // "Description of incident":"Description of incident",
  // "Check In":"Check In",
  // "code":"code",
  // "Address Line 1":"Address Line 1",
  // "City":"City",
  // "State/Province":"State/Province",
  // "Country":"Country",
  // "Attendance Radius (In Meters)":"Attendance Radius (In Meters)",
  // "Company Policy":"Company Policy",
  // "Employee Handbook":"Employee Handbook",
  // "Payslip Header":"Payslip Header",
  // "Payslip Footer":"Payslip Footer",
  // "Height":"Height",
  // "Width":"Width",
  // "ID Template":"ID Template",
  // "Select Organization Logo":"Select Organization Logo",
  // "Public Holiday":"Public Holiday",
  // "Holiday":"Holiday",
  // "Apply Shift Schduler":"Apply Shift Schduler",
  // "Pay":"Pay",
  // "Name":"Name",
  // "Shifts":"Shifts",
  // "Pay":"Pay",
  // "Negative Balance":"Negative Balance",
  // "This field is invalid":"This field is invalid",
  // "Leave Type":"Leave Type",
  // "Admin app":"Admin app",
  // "URL":"URL",
  // "Asset":"Asset",
  // "Allowance Code":"Allowance Code",
  // "Description":"Description",
  // "Cancel":"Cancel",
  // "Add":"Add",
  // "Document Type":"Document Type",
  // "Employee Group":"Employee Group",
  // "Job ID":"Job ID",
  // "Annoucement":"Annoucement",
  // "Course Type":"Course Type",
  // "System Logs":"System Logs",
  // "User":"User",
  // "User IP":"User IP",
  // "Location":"Location",
  // "Operation":"Operation",
  // "Affected Table":"Affected Table",
  // "Rows":"Rows",
  // "Timestamp":"Timestamp",




  ////Date 20/6/23
  "Point": "观点",
 "Add Payslip Header,Footer,organization logo,ID Template": "បន្ថែមបឋមកថាបើកប្រាក់បៀវត្សរ៍ បាតកថា និមិត្តសញ្ញាស្ថាប័ន គំរូលេខសម្គាល់",








///Date 12-06-24////////////////////
"Add on Note": "បន្ថែមលើចំណាំ",
"Workplan Evaluation": "ការវាយតម្លៃផែនការការងារ",
"Hr Letters": "អក្សរ Hr",
"Letter ": "លិខិត",
"HR Admin Payroll Processes": "ដំណើរការបើកប្រាក់បៀវត្សរ៍របស់អ្នកគ្រប់គ្រងធនធានមនុស្ស",
"Payroll Line Entry Record": "កំណត់ត្រាបញ្ជីប្រាក់បៀវត្សរ៍",
"Closed Payroll Line Entry": "បិទការបញ្ចូលបញ្ជីប្រាក់បៀវត្សរ៍",
"Cancelled Payroll Line Entry": "ការបញ្ចូលបញ្ជីប្រាក់បៀវត្សរ៍ត្រូវបានលុបចោល",
"Employee Monthly Target": "គោលដៅប្រចាំខែរបស់និយោជិត",
"Employee Log Activity": "សកម្មភាពកំណត់ហេតុបុគ្គលិក",
"Employee Summary Target Activity": "សកម្មភាពគោលដៅសង្ខេបរបស់បុគ្គលិក",
"Dependant Import": "ការនាំចូលអាស្រ័យ",
"Leave Import": "ចាកចេញពីការនាំចូល",
"Assets Import": "ទ្រព្យសម្បត្តិនាំចូល",
"Salary Import": "ប្រាក់ខែនាំចូល",
"KPI of completed Project": "KPI នៃគម្រោងដែលបានបញ្ចប់",
"KPI Attendance Employee": "និយោជិតចូលរួម KPI",
"KPI Attendance Organization": "អង្គការចូលរួម KPI",
"KPI Attendance Organization Listing": "ការចុះបញ្ជីអង្គការចូលរួម KPI",
"Groups CheckIN": "ការចុះឈ្មោះជាក្រុម",
"Groups Attendance Logs": "កំណត់ហេតុវត្តមានក្រុម",
"Project Groups": "ក្រុមគម្រោង",
"Use this  Access Code For Office Entry": "ប្រើលេខកូដចូលដំណើរការនេះសម្រាប់ការចូលការិយាល័យ",
"Workplan": "គំរោង​ការងារ",
"Goal": "ध्येय",
"Recommendations": "អនុសាសន៍",
"Feedback": "មតិកែលម្អ",
"HR Actions": "សកម្មភាពធនធានមនុស្ស",
"Links": "តំណភ្ជាប់",
"Target": "គោលដៅ",
"Activity": "សកម្មភាព",
"Evolution": "ការវិវត្តន៍",
"Overtime": "ओव्हरटाइम",
"Employee Overtime Request": "សំណើបន្ថែមម៉ោងរបស់និយោជិត",
"Attendance Import": "ការនាំចូលវត្តមាន",
"Exchange Rate": "អត្រា​ប្តូ​រ​ប្រាក់",
 "Cost": "ការចំណាយ",
 "Closed": "បិទ",
 "this": "នេះ",
"OFF": "បិទ",
"No Shows": "គ្មានការបង្ហាញ",
"No Shows": "គ្មានការបង្ហាញ",
"Total Performance": "ការអនុវត្តសរុប",
"Applicant": "អ្នកដាក់ពាក្យ",
"Resume": "रेझ्युमे",
"Close Date": "កាលបរិច្ឆេទបិទ",
"Job Id": "លេខសម្គាល់ការងារ",
"No Of Candidates Applied": "គ្មាន​បេក្ខជន​ត្រូវ​បាន​អនុវត្ត",
"Number Of": "លេខ",
"Minimum": "អប្បបរមា",
"Experience": "បទពិសោធន៍",
"Load": "ផ្ទុក",
"Send": "ផ្ញើ",
"Price": "តម្លៃ",
"Discounted": "បញ្ចុះតម្លៃ",
"SKU": "SKU",
"Brand": "ម៉ាក",
"Top List": "បញ្ជីកំពូល",
"Order": "បញ្ជាទិញ",
"For e.g.": "សម្រាប់ឧ",
"HR Letters": "អក្សរ HR",
"HR Letter Fields": "វាលលិខិត HR",





"IN": "IN",
"OUT": "ចេញ",
"Appointment": "ការណាត់ជួប",
"Valid": "មានសុពលភាព",
"CheckIN": "កត់​ឈ្មោះ​ចូល",
"Reported": "រាយការណ៍",
"Created On": "បានបង្កើតនៅលើ",
"Media": "ប្រព័ន្ធផ្សព្វផ្សាយ",
"Photo": "រូបថត",
"Holiday": "सुट्टी",
"Head": "ក្បាលs",
"Privilege": "ឯកសិទ្ធិ",
"Module": "ម៉ូឌុល",
"Delete": "हटवा",
"Activity Type": "ប្រភេទសកម្មភាព",
"Activity Status": "ស្ថានភាពសកម្មភាព",
"Activity Valuation %": "ការវាយតម្លៃសកម្មភាព %",
"Attendance Remarks": "ការកត់សម្គាល់វត្តមាន",
"Maximum": "អតិបរមា",
"Valuation": "ការវាយតម្លៃ",
"Exchange": "ផ្លាស់ប្តូរ",
"User": "वापरकर्ता",
"IP": "អាយភី",
"Operation": "ប្រតិបត្តិការ",
"Affected": "រងផលប៉ះពាល់",
"Table": "តុ",
"Rows": "ជួរដេក",
"Timestamp": "ត្រាពេលវេលា",
"Payroll Process": "ដំណើរការបើកប្រាក់ខែ",
"Remarks": "शेरा",
"To Date": "ដល់កាលបរិច្ឆេទ",
"Only Salary": "ប្រាក់ខែតែប៉ុណ្ណោះ",
"Next": "पुढे",
"Be Processed": "ដំណើរការ",
  "Early Leaving": "ការចាកចេញមុនកាលកំណត់",
  // "Over Time":"Over Time",
  "Time Late": "ពេលវេលាយឺត",
  "Done": "រួចរាល់",
  "Gross": "សរុប",
  "Pay": "បង់",
  "Unpaid": "មិនទាន់បង់ប្រាក់",
  "Dependant": "ពឹងផ្អែក",
  "Seniority": "ភាពចាស់ទុំ",
  "Advanced": "កម្រិតខ្ពស់",
  "Net": "សុទ្ធ",
  "Children": "កុមារ",
  "Ticket": "សំបុត្រ",



"Msg Send Successfully": "ផ្ញើសារដោយជោគជ័យ",
"Msg Not Send Successfully": "សារមិនបានផ្ញើដោយជោគជ័យ",



















  //Manage Tax Brackets             ,  
};
// }
// else
// {



// module.exports = {
//   "Employees List":
//     "Employees List",
//     "Dashboard":
//     "Dashboard",
//     "Select Organization":
//     "Select Organization",
//     "Status":
//     "Status",
//     "Select Department":
//     "Select Department",
//     "Select Positions":
//     "Select Positions",
//     "Export":
//     "Export",
//     "Import +":
//     "Import +",
//     "Update Qrcode":
//     "Update Qrcode",
//     "Search":
//     "Search",
// };

// }


